document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.promo-slider').forEach(function (slider) {
    var slides = Array.from(slider.querySelectorAll('.promo-slide'));
    if (!slides.length) return;

    slider.classList.add('js-native');
    var current = 0;

    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === 0);
    });

    if (slides.length > 1) {
      var prev = document.createElement('button');
      var next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = next.className = 'slick-arrow-custom promo-native-arrow';
      prev.setAttribute('aria-label', 'Previous');
      next.setAttribute('aria-label', 'Next');
      prev.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      slider.insertBefore(prev, slides[0]);
      slider.appendChild(next);
      prev.addEventListener('click', function () { show(current - 1); });
      next.addEventListener('click', function () { show(current + 1); });
      window.setInterval(function () { show(current + 1); }, 4000);
    }
  });
});
